export default {
  lang: {
    choose: '语言/Language',
    zhcn: '简体中文',
    zhtw: '繁體中文(臺灣)',
    en: 'English',
    es: 'Español',
    ru: 'Русский',
    de: 'Deutsch',
    sv: 'Svenska',
    ja: '日本語',
    changeok: 'Språkbyte lyckades'
  },
  btn: {
    ok: 'OK',
    cancel: 'Avbryt',
    cont: 'Fortsätt'
  },
  menu: {
    upload: 'Ladda upp',
    newfolder: 'Ny mapp',
    del: 'Radera',
    up: 'Överordnad mapp',
    refresh: 'Uppdatera',
    dfu: 'DFU',
  },
  status: {
    connected: 'Ansluten, version: ',
    version: 'Version:',
    mac: 'MAC-address:',
    loading: 'laddar…',
  },
  conn: {
    connect: 'Anslut',
    connecting: 'Ansluter…',
    disconnect: 'Koppla från…',
    consuccess: 'Lyckades ansluta till Pixl.js!',
    disconnected: 'Pixl.js har kopplats från!',
    connfailed: 'Pixl.js-anslutningen misslyckades!'
  },
  labels: {
    name: 'Namn',
    size: 'Storlek',
    type: 'Typ',
    remark: 'Anteckning'
  },
  contxmenu: {
    del: 'Radera…',
    rename: 'Byt namn…',
    prop: 'Inställningar…',
    format: 'Återställ…'
  },
  properties: {
    title: 'Inställningar',
    remark: 'Anteckning',
    entermsg: 'Vänligen ange anteckning',
    attrib: 'Attribut',
    hide: 'Göm',
    readonly: "Skrivskydd",
    errupdate: 'Misslyckades att uppdatera detaljer!',
    remarktoolong: 'Anteckningar kan bara vara 90 bytes!, detta är, 90 tecken eller 30 kinesiska tecken (nuvarande: ',
    remarktoolongend: ' bytes）'
  },
  upload: {
    title: 'Ladda upp',
    drag: 'Dra filer hit, eller ',
    click: 'klicka för att ladda upp.',
    maxsize: 'Den totala längden av filens sökväg får inte överstiga 63 bytes.',
    maxname: 'Filnamnet får inte överstiga 47 bytes.',
    closetitle: 'Vill du verkligen stänga?',
    closemessage: 'Stänger du dialogen rensar det uppladdningen och kommer att rensa uppladdningskön.',
    errupload: 'Uppladdningen misslyckades: '
  },
  format: {
    title: 'Formatera',
    messrow1a: 'Vill du formatera ',
    messrow1b: ' ?',
    messrow2: 'Formatering raderar all data!',
    messrow3: 'Formatering tar ungefär 10 seconds, vänligen vänta.',
    formatok: 'Formateringen färdig!',
    formaterr: 'Formatering misslyckades!: '
  },
  del: {
    title: 'Radera',
    message: 'Radera fil: ',
    messageend: ' ?',
    error: 'Misslyckades att radera filen!: ',
    deleteok: 'Filen raderad!'
  },
  dfumode: {
    title: 'DFU-läge',
    startconfirm: 'Vill du aktivera DFU-läge?',
    updateconfirm: 'DFU-läget är aktiverat. Vill du öppna sidan för DFU-uppgradering?',
    updatetitle: 'DFU-läge accepterat'
  },
  oldfirm: {
    title: 'Uppgraderingstips',
    message: 'Mjukvaran på din enhet är för låg. Vänligen uppgradera till den senaste versionen av mjukvaran innan du använder uppladdningsfunktionen.'
  },
  newfolder: {
    title: 'Ny mapp',
    message: 'Vänligen ange mappnamnet',
    newfoldererr: 'Misslyckades att skapa mapp!:'
  },
  rename: {
    title: 'Byt namn',
    message: 'Vänligen ange ett nytt filnamn: ',
    errrename: 'Namnbytet misslyckades!: ',
    nametoolong: 'Sökvägen får inte överstiga 63 bytes',
    pathtoolong: 'Filnamnet får inte överstiga 47 bytes'
  },
  drive: {
    message: '(Lagringen inte tillgänglig [felkod: ',
    messageend: '])'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/sv_SE.js